import { useTranslation } from "react-i18next";
import SectionHeader from "../../../../../util/component/SectionHeader";
import CreateThreshold from "../sections/CreateThresold";

const CashbackThresholdWizard = () => {
    const { t } = useTranslation('finance', { keyPrefix: 'cashback' });

    return (
        <>
            <SectionHeader title={t('threshold-wizard.title')} subtitle={t('threshold-wizard.subtitle')}/>
            <CreateThreshold/>
        </>
    )
}

export default CashbackThresholdWizard;